import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './components/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import RoleRoute from './components/RoleRoute';

import Login from './components/Login';
import Layout from './components/Layout';
import Inicial from './pages/Inicial';
import Producao from './pages/Producao';
import Vegetais from './pages/Vegetais';
import Ponto from './pages/Ponto';
import Martin from './pages/Martin';
import LerCSV from './pages/Ler-CSV';
import Caixa from './pages/Caixa';

import GerarPlanilhaProducao from './pages/GerarPlanilhaProducao';
import PreencherPlanilhaProducao from './pages/PreencherPlanilhaProducao';
import PlanilhaProducaoOnline from './pages/PlanilhaProducaoOnline';
import LercsvCupons from './pages/LercsvCupons';
import LercsvDescontos from './pages/LercsvDescontos';
import VegetaisMovimentacao from './pages/VegetaisMovimentacao';
import VegetaisVerificacao from './pages/VegetaisVerificacao';
import VegetaisPedido from './pages/VegetaisPedido';
import VegetaisEstoque from './pages/VegetaisEstoque';
import MartinPedido from './pages/MartinPedido';
import PontoPonto from './pages/PontoPonto';
import PontoFuncionarios from './pages/PontoFuncionarios';
import PontoEscala from './pages/PontoEscala';
import PontoFechar from './pages/PontoFechar';
import PontoCSV from './pages/PontoCSV';
import PontoPeriodo from './pages/PontoPeriodo';
import PontoAdiantamento from './pages/PontoAdiantamento';
import PontoFalta from './pages/PontoFalta';
import PontoEditar from './pages/PontoEditar';
import DashboardPeriodo from './pages/DashboardPeriodo';
import DashboardDiario from './pages/DashboardDiario';
import Dashboard from './pages/Dashboard';
import Abertura from './pages/Abertura';
import CaixaCaixa from './pages/CaixaCaixa';
import CaixaXLSX from './pages/CaixaXLSX';
import CaixaNovo from './pages/CaixaNovo';
import PontoXLSX from './pages/PontoXLSX';
import VendasHora from './pages/VendasHora';
import Prever from './pages/Prever';
import PreverMetas from './pages/PreverMetas';
import PreverPrevisao from './pages/PreverPrevisao';
import Inteligencia from './pages/Inteligencia';
import InteligenciaImpacto from './pages/InteligenciaImpacto';
import InteligenciaProcessar from './pages/InteligenciaProcessar';
import InteligenciaFeriado from './pages/InteligenciaFeriado';
import Pagamentos from './pages/Pagamentos';
import PagamentosVerificar from './pages/PagamentosVerificar';
import PagamentosCsvXlsx from './pages/PagamentosCsvXlsx';
import DashboardVendasDia from './pages/DashboardVendasDia';

const App = () => {
    return (
        <Router>
            <AuthProvider>
                <Routes>

                    <Route path="/login" element={<Login />} />

                    <Route
                        path="/"
                        element={
                            <PrivateRoute>
                                <Layout />
                            </PrivateRoute>
                        }
                    >
                        {/* Início */}
                        <Route
                            index
                            element={
                                <RoleRoute allowedRoles={['admin']}>
                                    <Inicial />
                                </RoleRoute>
                            }
                        />

                        {/* Martin */}
                        <Route
                            path="martin"
                            element={
                                <RoleRoute allowedRoles={['admin']}>
                                    <Martin />
                                </RoleRoute>
                            }
                        >
                            <Route index element={<MartinPedido />} />
                            <Route path="pedido" element={<MartinPedido />} />
                        </Route>

                        {/* Ler CSV */}
                        <Route
                            path="ler-csv"
                            element={
                                <RoleRoute allowedRoles={['admin']}>
                                    <LerCSV />
                                </RoleRoute>
                            }
                        >
                            <Route index element={<LercsvCupons />} />
                            <Route path="cupons" element={<LercsvCupons />} />
                            <Route path="descontos" element={<LercsvDescontos />} />
                        </Route>

                        {/* Caixa */}
                        <Route
                            path="caixa"
                            element={
                                <RoleRoute allowedRoles={['admin', 'gerente']}>
                                    <Caixa />
                                </RoleRoute>
                            }
                        >
                            <Route index element={<CaixaCaixa />} />
                            <Route path="caixa-caixa" element={<CaixaCaixa />} />
                            <Route path="caixa-novo" element={<CaixaNovo />} />
                            <Route path="caixa-xlsx" element={<CaixaXLSX />} />
                        </Route>

                        {/* Produção */}
                        <Route
                            path="producao"
                            element={
                                <RoleRoute allowedRoles={['admin']}>
                                    <Producao />
                                </RoleRoute>
                            }
                        >
                            <Route index element={<GerarPlanilhaProducao />} />
                            <Route path="gerar" element={<GerarPlanilhaProducao />} />
                            <Route path="preencher" element={<PreencherPlanilhaProducao />} />
                            <Route path="online" element={<PlanilhaProducaoOnline />} />
                        </Route>

                        {/* Vegetais */}
                        <Route
                            path="vegetais"
                            element={
                                <RoleRoute allowedRoles={['admin']}>
                                    <Vegetais />
                                </RoleRoute>
                            }
                        >
                            <Route index element={<VegetaisMovimentacao />} />
                            <Route path="movimentacao" element={<VegetaisMovimentacao />} />
                            <Route path="verificacao" element={<VegetaisVerificacao />} />
                            <Route path="pedido" element={<VegetaisPedido />} />
                            <Route path="estoque" element={<VegetaisEstoque />} />
                        </Route>

                        {/* Ponto */}
                        <Route
                            path="ponto"
                            element={
                                <RoleRoute allowedRoles={['admin', 'gerente']}>
                                    <Ponto />
                                </RoleRoute>
                            }
                        >
                            <Route index element={<PontoPonto />} />
                            <Route path="ponto" element={<PontoPonto />} />
                            <Route path="funcionarios" element={<PontoFuncionarios />} />
                            <Route path="escala" element={<PontoEscala />} />
                            <Route path="fechar" element={<PontoFechar />} />
                            <Route path="csv" element={<PontoCSV />} />
                            <Route path="ponto-xlsx" element={<PontoXLSX />} />
                            <Route path="periodo" element={<PontoPeriodo />} />
                            <Route path="adiantamento" element={<PontoAdiantamento />} />
                            <Route path="falta" element={<PontoFalta />} />
                            <Route path="Editar" element={<PontoEditar />} />
                        </Route>

                        {/* Dashboard */}
                        <Route
                            path="dashboard"
                            element={
                                <RoleRoute allowedRoles={['admin']}>
                                    <Dashboard />
                                </RoleRoute>
                            }
                        >
                            <Route index element={<DashboardDiario />} />
                            <Route path="dashboard-diario" element={<DashboardDiario />} />
                            <Route path="dashboard-periodo" element={<DashboardPeriodo />} />
                            <Route path="dashboard-vendas-dia" element={<DashboardVendasDia />} />
                        </Route>

                        {/* Abertura */}
                        <Route
                            path="abertura"
                            element={
                                <RoleRoute allowedRoles={['admin']}>
                                    <Abertura />
                                </RoleRoute>
                            }
                        />

                        {/* Vendas Hora */}
                        <Route
                            path="vendas-hora"
                            element={
                                <RoleRoute allowedRoles={['admin']}>
                                    <VendasHora />
                                </RoleRoute>
                            }
                        />

                        {/* Prever */}
                        <Route
                            path="prever"
                            element={
                                <RoleRoute allowedRoles={['admin']}>
                                    <Prever />
                                </RoleRoute>
                            }
                        >
                            <Route index element={<PreverMetas />} />
                            <Route path="prever-metas" element={<PreverMetas />} />
                            <Route path="prever-previsao" element={<PreverPrevisao />} />
                        </Route>

                        {/* Inteligência */}
                        <Route
                            path="inteligencia"
                            element={
                                <RoleRoute allowedRoles={['admin']}>
                                    <Inteligencia />
                                </RoleRoute>
                            }
                        >
                            <Route index element={<InteligenciaImpacto />} />
                            <Route path="inteligencia-impacto" element={<InteligenciaImpacto />} />
                            <Route path="inteligencia-processar" element={<InteligenciaProcessar />} />
                            <Route path="inteligencia-feriado" element={<InteligenciaFeriado />} />
                        </Route>

                        {/* Pagamentos */}
                        <Route
                            path="pagamentos"
                            element={
                                <RoleRoute allowedRoles={['admin', 'gerente']}>
                                    <Pagamentos />
                                </RoleRoute>
                            }
                        >
                            <Route index element={<PagamentosVerificar />} />
                            <Route path="pagamentos-verificar" element={<PagamentosVerificar />} />
                            <Route path="pagamentos-csv-xlsx" element={<PagamentosCsvXlsx />} />
                        </Route>

                    </Route>
                </Routes>
            </AuthProvider>
        </Router>
    );
};

export default App;